const topThreeElements = 3;

class SearchAutocompleteUtils {
    static showTopThreeElements = <T>(autocompleteItems: T[], showTopResults: boolean): T[] => {
        return showTopResults ? autocompleteItems.slice(0, topThreeElements) : autocompleteItems;
    };
}

export { SearchAutocompleteUtils };
